import Validation from "utils/validation.utils";
import locale from "localization";
import moment from "moment";
import { dateTimeFormatV2 } from "utils";
const initialState = (bankDeposit) => {
  return {
    date: {
      name: "date",
      value: bankDeposit?.depositedAt ? moment(bankDeposit?.depositedAt).toDate() : new Date(),
      label: locale.date,
      required: true,
      validations: [Validation.required()],
    },
    time: {
      name: "time",
      value: bankDeposit?.depositedAt ? moment(bankDeposit?.depositedAt).toDate() : new Date(),
      label: locale.time,
      placeholder: locale.setTime,
      required: true,
      validations: [Validation.required()],
    },
    shiftId: {
      name: "shiftId",
      value: bankDeposit?.shift?.shiftId,
      label: bankDeposit?.shift?.startShift
        ? `${dateTimeFormatV2(bankDeposit.shift.startShift)} - ${dateTimeFormatV2(
            bankDeposit.shift.endShift
          )}`
        : locale.selectShift,
      placeholder: locale.selectShift,
      required: true,
      validations: [Validation.required()],
      disableAllOption: true,
    },
    type: {
      name: "type",
      value: bankDeposit?.type || "",
      variant: "purple",
      label: locale.depositType,
      placeholder: locale.selectDepositType,
      required: true,
      validations: [Validation.required()],
    },
    amount: {
      name: "amount",
      value: bankDeposit?.amount || "",
      label: locale.amount,
      required: true,
      isPriceValue: true,
      innerLabel: true,
      min: 1,
      max: 99999999999.99,
      placeholder: "0.00",
      validations: [Validation.required(), Validation.min(1)],
    },
    slip: {
      name: "slip",
      value: bankDeposit?.imageUrl || null,
      type: "image",
      text: locale.uploadImage,
      validatedDimension: false,
      buttonProps: {
        style: {
          backgroundColor: "transparent",
          color: "#5349b7",
          borderColor: "#5349b7",
          fontWeight: "500",
        },
        variant: "outlined",
      },
    },
    remarks: {
      name: "remarks",
      value: bankDeposit?.remarks || "",
      label: locale.remarks,
      placeholder: locale.sampleRemarks,
      maxLength: 500,
    },
  };
};

export default initialState;
